// import React, { useState, useEffect } from 'react';
// import { getTeamMembers, addTeamMember, updateTeamMember, deleteTeamMember } from '../../api/team';
// import { warehousesAPI } from '../../api/warehouses';
// import { useOfflineData } from '../../hooks/useOfflineData';
// import { useModal } from '../../hooks/useModal';
// import { useToast } from '../../hooks/useToast';
// import { dbHelpers } from '../../db/database';
// import Modal from '../common/Modal';
// import './TeamManagement.css';

// function TeamManagement() {
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [editingUser, setEditingUser] = useState(null);
//   const [formData, setFormData] = useState({
//     username: '',
//     email: '',
//     first_name: '',
//     last_name: '',
//     phone: '',
//     password: '',
//     role: 'staff',
//     assigned_warehouse: ''
//   });
//   const [error, setError] = useState('');

//   const { isOpen, modalConfig, openModal, closeModal } = useModal();
//   const toast = useToast();

//   const { data: allTeamMembers, loading: teamLoading } = useOfflineData(
//     async () => {
//       const data = await getTeamMembers();
//       return data;
//     },
//     dbHelpers.getTeamMembers,
//     dbHelpers.saveTeamMembers
//   );

//   const { data: allWarehouses, loading: warehousesLoading } = useOfflineData(
//     () => warehousesAPI.getAll(),
//     dbHelpers.getWarehouses
//   );

//   const warehouses = allWarehouses;
//   const loading = teamLoading || warehousesLoading;

//   const [localMembers, setLocalMembers] = useState(null);

//   // Sync localMembers when fresh API data arrives
//   useEffect(() => {
//     if (!teamLoading && allTeamMembers.length >= 0) {
//       setLocalMembers(allTeamMembers);
//     }
//   }, [allTeamMembers, teamLoading]);


// const teamMembers = (localMembers ?? []).filter(m => m.is_active !== false);


//   function handleInputChange(e) {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   }

//   async function handleSubmit(e) {
//     e.preventDefault();
//     setError('');

//     if (!formData.username || !formData.email || !formData.first_name ||
//       !formData.last_name || (!editingUser && !formData.password)) {
//       setError('Please fill in all required fields');
//       return;
//     }

//     if (!editingUser && formData.password.length < 8) {
//       setError('Password must be at least 8 characters');
//       return;
//     }

//     try {
//       if (editingUser) {
//         const updateData = {
//           first_name: formData.first_name,
//           last_name: formData.last_name,
//           email: formData.email,
//           phone: formData.phone,
//           role: formData.role,
//           assigned_warehouse: formData.assigned_warehouse || null
          
//         };

//         if (navigator.onLine) {
//           await updateTeamMember(editingUser.id, updateData);
//         } else {
//           await dbHelpers.updateTeamMember(editingUser.id, updateData);
//         }

//         // ✅ Update member in local state directly
//         setLocalMembers(prev =>
//           (prev ?? allTeamMembers).map(m =>
//             m.id === editingUser.id ? { ...m, ...updateData } : m
//           )
//         );
//         toast.success('✅ Team member updated successfully');

//       } else {
//         let newMember;
//         if (navigator.onLine) {
//           const response = await addTeamMember(formData);
//           newMember = response.data || { ...formData, id: Date.now() };
//         } else {
//           const tempId = `temp_${Date.now()}`;
//           newMember = { ...formData, id: tempId };
//           await dbHelpers.saveTeamMember(newMember);
//           await dbHelpers.savePendingChange({
//             type: 'CREATE',
//             entity: 'team_members',
//             entityId: tempId,
//             data: formData,
//             timestamp: Date.now()
//           });
//         }

//         // ✅ Add new member to local state directly
//         setLocalMembers(prev => [...(prev ?? allTeamMembers), newMember]);
//         toast.success('✅ Team member added successfully');
//       }

//       resetForm();

//     } catch (err) {
//       // setError(err.response?.data?.error || 'Failed to save team member');
//       const errorData = err.response?.data;
  
//       if (errorData?.error) {
//         // ⭐ Single error message — show on relevant field
//         if (errorData.error.toLowerCase().includes('email')) {
//           setError('email: ' + errorData.error);
//         } else {
//           setError(errorData.error);
//         }
//       } else if (errorData && typeof errorData === 'object') {
//         // ⭐ Field-level errors from DRF serializer
//         const fieldErrors = Object.entries(errorData)
//           .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
//           .join(' | ');
//         setError(fieldErrors);
//       } else {
//         setError('Failed to save team member');
//       }
      
//     }
//   }

//   function handleEdit(user) {
//     setEditingUser(user);
//     setFormData({
//       username: user.username,
//       email: user.email,
//       first_name: user.first_name,
//       last_name: user.last_name,
//       phone: user.phone || '',
//       password: '',
//       role: user.role,
//       assigned_warehouse: user.assigned_warehouse?.id || ''
//     });
//     setShowAddForm(true);
//     setError('');
//   }

//   async function performDelete(user) {
//     try {
//       if (navigator.onLine) {
//         await deleteTeamMember(user.id);
//       } else {
//         await dbHelpers.deleteTeamMember(user.id);
//       }

//       // ✅ Remove from local state directly — no reload needed
//       setLocalMembers(prev =>
//         (prev ?? allTeamMembers).filter(m => m.id !== user.id)
//       );

//       closeModal();
//       toast.success(`✅ ${user.first_name} ${user.last_name} removed successfully`);
//     } catch (err) {
//       closeModal();
//       toast.error('Failed to remove team member');
//     }
//   }

//   function handleDelete(user) {
//     openModal({
//       title: 'Remove Team Member?',
//       message: `Are you sure you want to remove ${user.first_name} ${user.last_name}? This action cannot be undone.`,
//       type: 'danger',
//       confirmText: 'Remove Member',
//       cancelText: 'Cancel',
//       onConfirm: () => performDelete(user)
//     });
//   }

//   function resetForm() {
//     setFormData({
//       username: '',
//       email: '',
//       first_name: '',
//       last_name: '',
//       phone: '',
//       password: '',
//       role: 'staff',
//       assigned_warehouse: ''
//     });
//     setShowAddForm(false);
//     setEditingUser(null);
//     setError('');
//   }

//   function cancelEdit() {
//     resetForm();
//   }

//   if (loading) {
//     return (
//       <div className="loading-screen">
//         <div className="spinner"></div>
//         <p>Loading team...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="team-management fade-in">
//       <div className="team-header">
//         <div>
//           <h1>Team Management</h1>
//           <p className="subtitle">{teamMembers.length} team members</p>
//         </div>
//         <button
//           className="btn-primary-small"
//           onClick={() => setShowAddForm(!showAddForm)}
//         >
//           {showAddForm ? '✕ Cancel' : '+ Add Team Member'}
//         </button>
//       </div>

//       {error && (
//         <div className="alert alert-error">
//           ✕ {error}
//         </div>
//       )}

//       {/* Modal Form */}
//       {showAddForm && (
//         <div className="modal-overlay" onClick={cancelEdit}>
//           <div className="add-member-form" onClick={(e) => e.stopPropagation()}>
//             <h2>{editingUser ? 'Edit Team Member' : 'Add New Team Member'}</h2>
//             <form onSubmit={handleSubmit}>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Username *</label>
//                   <input
//                     type="text"
//                     name="username"
//                     value={formData.username}
//                     onChange={handleInputChange}
//                     disabled={editingUser !== null}
//                     required
//                   />
//                   {editingUser && <small>Cannot be changed</small>}
//                 </div>

//                 <div className="form-group">
//                   <label>Email *</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="form-row">
//                 <div className="form-group">
//                   <label>First Name *</label>
//                   <input
//                     type="text"
//                     name="first_name"
//                     value={formData.first_name}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Last Name *</label>
//                   <input
//                     type="text"
//                     name="last_name"
//                     value={formData.last_name}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleInputChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Role *</label>
//                   <select
//                     name="role"
//                     value={formData.role}
//                     onChange={handleInputChange}
//                     required
//                   >
//                     <option value="staff">Staff</option>
//                     <option value="manager">Manager</option>
//                     <option value="admin">Admin</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label>Assigned Warehouse</label>
//                 <select
//                   name="assigned_warehouse"
//                   value={formData.assigned_warehouse}
//                   onChange={handleInputChange}
//                 >
//                   <option value="">No warehouse assigned</option>
//                   {warehouses.map(warehouse => (
//                     <option key={warehouse.id} value={warehouse.id}>
//                       {warehouse.name} - {warehouse.location}
//                     </option>
//                   ))}
//                 </select>
//                 <small>
//                   {warehouses.length === 0
//                     ? '⚠️ No warehouses available'
//                     : `${warehouses.length} warehouses available`}
//                 </small>
//               </div>

//               {!editingUser && (
//                 <div className="form-group">
//                   <label>Password *</label>
//                   <input
//                     type="password"
//                     name="password"
//                     value={formData.password}
//                     onChange={handleInputChange}
//                     required={!editingUser}
//                     minLength="8"
//                   />
//                   <small>Minimum 8 characters</small>
//                 </div>
//               )}

//               <div className="form-actions">
//                 <button type="button" className="btn-secondary" onClick={cancelEdit}>
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn-primary-small">
//                   {editingUser ? 'Update Member' : 'Add Member'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       <div className="team-grid">
//         {teamMembers.map(member => (
//           <div key={member.id} className="team-card">
//             <div className="member-avatar">
//               {member.first_name?.charAt(0)}{member.last_name?.charAt(0)}
//             </div>

//             <div className="member-info">
//               <h3>{member.first_name} {member.last_name}</h3>
//               <p className="member-email">{member.email}</p>
//               {member.phone && <p className="member-phone">📞 {member.phone}</p>}
//               {member.assigned_warehouse && (
//                 <p className="member-warehouse">🏭 {member.assigned_warehouse.name}</p>
//               )}
//             </div>

//             <div className={`role-badge role-${member.role}`}>
//               {member.role === 'admin' && '👑'}
//               {member.role === 'manager' && '📊'}
//               {member.role === 'staff' && '👤'}
//               {' '}{member.role}
//             </div>

//             <div className="member-actions">
//               <button className="btn-edit" onClick={() => handleEdit(member)}>
//                 ✏️ Edit
//               </button>
//               <button className="btn-delete" onClick={() => handleDelete(member)}>
//                 🗑️ Remove
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {teamMembers.length === 0 && (
//         <div className="empty-state">
//           <p>No team members yet. Add your first team member!</p>
//         </div>
//       )}

//       <Modal isOpen={isOpen} onClose={closeModal} {...modalConfig} />
//     </div>
//   );
// }

// export default TeamManagement;


import React, { useState, useEffect } from 'react';
import { getTeamMembers, addTeamMember, updateTeamMember, deleteTeamMember } from '../../api/team';
import { warehousesAPI } from '../../api/warehouses';
import { useOfflineData } from '../../hooks/useOfflineData';
import { useModal } from '../../hooks/useModal';
import { useToast } from '../../hooks/useToast';
import { dbHelpers } from '../../db/database';
import syncService from '../../services/syncService';
import Modal from '../common/Modal';
import './TeamManagement.css';

function TeamManagement() {
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    password: '',
    role: 'staff',
    assigned_warehouse: ''
  });
  const [error, setError] = useState('');
  const [syncing, setSyncing] = useState(false);

  const { isOpen, modalConfig, openModal, closeModal } = useModal();
  const toast = useToast();

  // ✅ Local state — source of truth for the UI
  const [teamMembers, setTeamMembers] = useState([]);
  const [loadingTeam, setLoadingTeam] = useState(true);

  const { data: allWarehouses, loading: warehousesLoading } = useOfflineData(
    () => warehousesAPI.getAll(),
    dbHelpers.getWarehouses
  );

  const warehouses = allWarehouses;

  // ✅ Load team: cache first (no flash), then API silently
  useEffect(() => {
    loadTeam();
  }, []);

  async function loadTeam() {
    setLoadingTeam(true);
    try {
      // Step 1: Show cached data instantly
      const cached = await dbHelpers.getTeamMembers();
      // console.log('CACHED:', cached);

      const activeCache = cached.filter(m => m.is_active !== false);
      if (activeCache.length > 0) {
        setTeamMembers(activeCache);
        setLoadingTeam(false); // stop spinner immediately
      }

      // Step 2: Fetch fresh from API silently
      if (navigator.onLine) {
        const fresh = await getTeamMembers();
        // console.log('FRESH:', fresh);
        const activeFresh = fresh.filter(m => m.is_active !== false);
        await dbHelpers.saveTeamMembers(fresh);
        setTeamMembers(activeFresh);
      }
    } catch (err) {
      toast.error('Failed to load team members');
    }
    setLoadingTeam(false);
  }

  async function handleSync() {
    if (!navigator.onLine) {
      toast.error('Cannot sync while offline');
      return;
    }
    setSyncing(true);
    const result = await syncService.fullSync();
    if (result.success) {
      await loadTeam();
      toast.success('✅ Team synced successfully');
    } else {
      toast.error('❌ Sync failed: ' + result.message);
    }
    setSyncing(false);
  }

  function handleInputChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!formData.username || !formData.email || !formData.first_name ||
      !formData.last_name || (!editingUser && !formData.password)) {
      setError('Please fill in all required fields');
      return;
    }

    if (!editingUser && formData.password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    try {
      if (editingUser) {
        const updateData = {
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          phone: formData.phone,
          role: formData.role,
          assigned_warehouse: formData.assigned_warehouse || null
        };

        if (navigator.onLine) {
          await updateTeamMember(editingUser.id, updateData);
          // ✅ Update in IndexedDB
          await dbHelpers.updateTeamMember(editingUser.id, updateData);
        } else {
          // ✅ Offline: save locally and queue for sync
          await dbHelpers.updateTeamMember(editingUser.id, updateData);
          toast.info('⚠️ Offline: Changes saved locally, will sync when online');
        }

        setTeamMembers(prev =>
          prev.map(m => m.id === editingUser.id ? { ...m, ...updateData } : m)
        );
        toast.success('✅ Team member updated successfully');

      } else {
        const payload = {
          ...formData,
          assigned_warehouse: formData.assigned_warehouse || null
        };

        if (navigator.onLine) {
          const response = await addTeamMember(payload);
          const newMember = response.data || { ...payload, id: Date.now() };
          // ✅ Save to IndexedDB
          await dbHelpers.saveTeamMember(newMember);
          setTeamMembers(prev => [...prev, newMember]);
        } else {
          // ✅ Offline: save locally and queue for sync
          const tempId = `temp_${Date.now()}`;
          const newMember = { ...payload, id: tempId, is_active: true };
          await dbHelpers.saveTeamMember(newMember);
          await dbHelpers.queueSync('team_members', tempId, 'create', payload);
          setTeamMembers(prev => [...prev, newMember]);
          toast.info('⚠️ Offline: Team member saved locally, will sync when online');
        }

        toast.success('✅ Team member added successfully');
      }

      resetForm();

    } catch (err) {
      const errorData = err.response?.data;
      if (errorData?.error) {
        setError(errorData.error);
      } else if (errorData && typeof errorData === 'object') {
        const fieldErrors = Object.entries(errorData)
          .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
          .join(' | ');
        setError(fieldErrors);
      } else {
        setError('Failed to save team member');
      }
    }
  }

  function handleEdit(user) {
    setEditingUser(user);
    setFormData({
      username: user.username,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      phone: user.phone || '',
      password: '',
      role: user.role,
      assigned_warehouse: user.assigned_warehouse?.id || ''
    });
    setShowAddForm(true);
    setError('');
  }

  async function performDelete(user) {
    try {
      if (navigator.onLine) {
        await deleteTeamMember(user.id);
        // ✅ Remove from IndexedDB too
        await dbHelpers.deleteTeamMember(user.id);
      } else {
        // ✅ Offline: remove locally, queue delete for sync
        await dbHelpers.deleteTeamMember(user.id);
        await dbHelpers.markForDeletion('team_members', user.id);
        toast.info('⚠️ Offline: Will remove from server when back online');
      }

      setTeamMembers(prev => prev.filter(m => m.id !== user.id));
      closeModal();
      toast.success(`✅ ${user.first_name} ${user.last_name} removed successfully`);
    } catch (err) {
      closeModal();
      toast.error('Failed to remove team member');
    }
  }

  function handleDelete(user) {
    openModal({
      title: 'Remove Team Member?',
      message: `Are you sure you want to remove ${user.first_name} ${user.last_name}? This action cannot be undone.`,
      type: 'danger',
      confirmText: 'Remove Member',
      cancelText: 'Cancel',
      onConfirm: () => performDelete(user)
    });
  }

  function resetForm() {
    setFormData({
      username: '',
      email: '',
      first_name: '',
      last_name: '',
      phone: '',
      password: '',
      role: 'staff',
      assigned_warehouse: ''
    });
    setShowAddForm(false);
    setEditingUser(null);
    setError('');
  }

  if (loadingTeam && teamMembers.length === 0) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading team...</p>
      </div>
    );
  }

  return (
    <div className="team-management fade-in">
      <div className="team-header">
        <div>
          <h1>Team Management</h1>
          <p className="subtitle">{teamMembers.length} team members</p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={handleSync}
            className="btn-sync"
            disabled={syncing || !navigator.onLine}
          >
            {syncing ? '⟳ Syncing...' : '🔄 Sync'}
          </button>
          <button
            className="btn-primary-small"
            onClick={() => setShowAddForm(!showAddForm)}
          >
            {showAddForm ? '✕ Cancel' : '+ Add Team Member'}
          </button>
        </div>
      </div>

      {error && (
        <div className="alert alert-error">✕ {error}</div>
      )}

      {/* Modal Form */}
      {showAddForm && (
        <div className="modal-overlay" onClick={resetForm}>
          <div className="add-member-form" onClick={(e) => e.stopPropagation()}>
            <h2>{editingUser ? 'Edit Team Member' : 'Add New Team Member'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Username *</label>
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    disabled={editingUser !== null}
                    required
                  />
                  {editingUser && <small>Cannot be changed</small>}
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>First Name *</label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Last Name *</label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Role *</label>
                  <select name="role" value={formData.role} onChange={handleInputChange} required>
                    <option value="staff">Staff</option>
                    <option value="manager">Manager</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Assigned Warehouse</label>
                <select
                  name="assigned_warehouse"
                  value={formData.assigned_warehouse}
                  onChange={handleInputChange}
                >
                  <option value="">No warehouse assigned</option>
                  {warehouses.map(warehouse => (
                    <option key={warehouse.id} value={warehouse.id}>
                      {warehouse.name} - {warehouse.location}
                    </option>
                  ))}
                </select>
                <small>
                  {warehouses.length === 0
                    ? '⚠️ No warehouses available'
                    : `${warehouses.length} warehouses available`}
                </small>
              </div>

              {!editingUser && (
                <div className="form-group">
                  <label>Password *</label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required={!editingUser}
                    minLength="8"
                  />
                  <small>Minimum 8 characters</small>
                </div>
              )}

              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={resetForm}>
                  Cancel
                </button>
                <button type="submit" className="btn-primary-small">
                  {editingUser ? 'Update Member' : 'Add Member'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="team-grid">
        {teamMembers.map(member => (
          <div key={member.id} className="team-card">
            <div className="member-avatar">
              {member.first_name?.charAt(0)}{member.last_name?.charAt(0)}
            </div>
            <div className="member-info">
              <h3>{member.first_name} {member.last_name}</h3>
              <p className="member-email">{member.email}</p>
              {member.phone && <p className="member-phone">📞 {member.phone}</p>}
              {member.assigned_warehouse && (
                <p className="member-warehouse">🏭 {member.assigned_warehouse.name}</p>
              )}
            </div>
            <div className={`role-badge role-${member.role}`}>
              {member.role === 'admin' && '👑'}
              {member.role === 'manager' && '📊'}
              {member.role === 'staff' && '👤'}
              {' '}{member.role}
            </div>
            <div className="member-actions">
              <button className="btn-edit" onClick={() => handleEdit(member)}>
                ✏️ Edit
              </button>
              <button className="btn-delete" onClick={() => handleDelete(member)}>
                🗑️ Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      {teamMembers.length === 0 && !loadingTeam && (
        <div className="empty-state">
          <p>No team members yet. Add your first team member!</p>
        </div>
      )}

      <Modal isOpen={isOpen} onClose={closeModal} {...modalConfig} />
    </div>
  );
}

export default TeamManagement;